const black = '#0D0E0C';
const white = '#FFFFFF';
const gray = '#EAEFE8';
const grayLight = '#F8F8F8';
const steelGray = '#575C66';
const accent = '#93F224';

const colors = {
  bg: { black, white, gray, grayLight, accent, neonLight: '#E3F9A4' },
  text: {
    black,
    white,
    steelGray,
    blackHalf: 'rgba(13, 14, 12,.5)',
    gray: '#A7A9A5',
    darkGray: '#333531',
    grayMagengo: '#575C66',
  },
  buttons: { black, disabled: '#E6E9EE', gray },
  line: { black, white, gray, grayLight, steelGray, accent },
  icon: { black, gray },
  alert: { active: '#D74242', default: '#FF3A40', hover: '#D50B11', secondary: '#FFE4D7' },
  culturalCode: { accent: '#E70000', bg: '#2C2927', text: '#2C2927', headerBg: '#1F1C1A' },
};

export default colors;
